import { useQuery } from "@tanstack/react-query";

import { getSegmentEntries } from "services";

import { GET_FEATBIT_SEGMENT_ENTRIES } from "consts";

import { SegmentEntryList, SegmentListRequest } from "models";

// The segment can change in FeatBit at any time, so it is always read fresh.
export const useGetSegmentEntries = ({ envId, segmentId, type }: Partial<SegmentListRequest>) =>
  useQuery<SegmentEntryList>({
    queryKey: [GET_FEATBIT_SEGMENT_ENTRIES, envId, segmentId, type],
    queryFn: () => getSegmentEntries({ envId: envId!, segmentId: segmentId!, type: type! }),
    enabled: Boolean(envId && segmentId && type),
    refetchOnMount: "always",
    staleTime: 0,
    retry: false,
  });
